import { defineComponent as _defineComponent } from 'vue'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import SingleJobLayer from '@/components/field-view-next/layers/SingleJobLayer.vue'
import { useState } from 'vuex-composition-helpers'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobTripMap',
  props: {
    jobNumber: null
  },
  emits: ["distance-calculated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'distance-calculated', data: number)
}), expose: any, slots: any, attrs: any }) {





const { mapCenterPoint } = useState('organizationConfig', ['mapCenterPoint'])
const center = computed(() => {
  return {
    lat: mapCenterPoint.value.latitude,
    lng: mapCenterPoint.value.longitude,
  }
})

const handleNewMapLegacyDistanceCalculation = (distance: number) => {
  emits('distance-calculated', distance)
}

return { __sfc: true,emits, mapCenterPoint, center, handleNewMapLegacyDistanceCalculation, FieldMap, SingleJobLayer }
}

})